// extracted by mini-css-extract-plugin
export const arrow = "InsightCategoriesRibbon__arrow__s4P-W";
export const atlasGrotesk = "'AtlasGrotesk'";
export const bold = "700";
export const category = "InsightCategoriesRibbon__category__ugiy3";
export const categoryWidth = "var(--category-width)";
export const counterWrapper = "InsightCategoriesRibbon__counterWrapper__Cjrou";
export const dragging = "InsightCategoriesRibbon__dragging__9J4Ri";
export const headBgColorExternal = "var(--salt)";
export const headBgColorInternal = "var(--shade)";
export const headBgColorShrunkSidebar = "var(--slate)";
export const hidden = "InsightCategoriesRibbon__hidden__0uCF3";
export const highlighter = "InsightCategoriesRibbon__highlighter__gMaVl";
export const icon = "InsightCategoriesRibbon__icon__9mFCm";
export const iconContainer = "InsightCategoriesRibbon__iconContainer__8Yg8x";
export const left = "InsightCategoriesRibbon__left__nF6Ef";
export const medium = "500";
export const menu = "InsightCategoriesRibbon__menu__nVexV";
export const regular = "InsightCategoriesRibbon__regular__eLBMd";
export const ribbon = "InsightCategoriesRibbon__ribbon__4lyww font-faces__sansMedium__DqLMY font-faces__sans__uCf65";
export const right = "InsightCategoriesRibbon__right__GdKE9";
export const sans = "'sans'";
export const scrollable = "InsightCategoriesRibbon__scrollable__Ug0sg";
export const selected = "InsightCategoriesRibbon__selected__g7zuX";
export const semibold = "600";
export const serif = "'serif'";
export const textPositioner = "InsightCategoriesRibbon__textPositioner__DnUtc";
export const textWrapper = "InsightCategoriesRibbon__textWrapper__nTqK3";
export const white = "InsightCategoriesRibbon__white__fgB2I";